import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Sword, Map, Puzzle, Car, Brain, Trophy, 
  Wand2, Building2, Joystick, Layers, Swords, Target 
} from 'lucide-react';

const Genres = () => {
  const { t } = useTranslation();

  const genres = [
    { key: 'action', icon: Sword },
    { key: 'adventure', icon: Map },
    { key: 'puzzle', icon: Puzzle },
    { key: 'racing', icon: Car },
    { key: 'strategy', icon: Brain },
    { key: 'sports', icon: Trophy },
    { key: 'rpg', icon: Wand2 },
    { key: 'simulation', icon: Building2 },
    { key: 'arcade', icon: Joystick },
    { key: 'platform', icon: Layers },
    { key: 'fighting', icon: Swords },
    { key: 'shooter', icon: Target }
  ];

  return (
    <section id="genres" className="py-20 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-5xl font-bold mb-4">
            <span className="gaming-gradient-text">{t('genres.title')}</span>
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            {t('genres.subtitle')}
          </p>
        </div>

        {/* Genre tags */}
        <div className="flex flex-wrap justify-center gap-4">
          {genres.map((genre) => (
            <button
              key={genre.key}
              className="genre-tag px-6 py-3 rounded-full flex items-center gap-3 hover:cursor-pointer"
            >
              <genre.icon className="w-5 h-5 text-red-400" />
              <span className="font-medium">{t(`genres.list.${genre.key}`)}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Genres;
